import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { EnvelopeIcon, PencilSimpleIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { CountryFlag, IconButton, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CustomerInfoSection = ({
  title,
  editTooltip,
  sendEmailTooltip,
  address,
  contactAddress = address,
  email,
  onEdit,
  allowEdit,
  onSendEmail,
  allowSendEmail,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.SectionContainer>
      <Styles.SectionTitleContainer>
        <Text type="titleS">{title}</Text>
        <Styles.ActionsTitleContainer>
          {allowSendEmail && (
            <Tooltip title={sendEmailTooltip}>
              <IconButton
                variant="text"
                icon={<EnvelopeIcon alt={sendEmailTooltip} size={24} color={theme.colors.outline.default} />}
                onClick={onSendEmail}
              />
            </Tooltip>
          )}
          {allowEdit && (
            <Tooltip title={editTooltip}>
              <IconButton
                variant="text"
                icon={<PencilSimpleIcon alt={editTooltip} size={24} color={theme.colors.outline.default} />}
                onClick={onEdit}
              />
            </Tooltip>
          )}
        </Styles.ActionsTitleContainer>
      </Styles.SectionTitleContainer>
      <Styles.SectionInfoContainer>
        <Styles.InfoColumnContainer>
          <Styles.InfoContainer>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {t('Nombre cliente')}
            </Text>
            <Text type="bodyMRegular">
              {contactAddress?.first_name} {contactAddress?.last_name}
            </Text>
          </Styles.InfoContainer>
          <Styles.InfoContainer>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {t('Email')}
            </Text>
            <Text type="bodyMRegular">{email}</Text>
          </Styles.InfoContainer>
        </Styles.InfoColumnContainer>
        <Styles.InfoColumnContainer>
          <Styles.InfoContainer>
            <Text type="bodyMRegular" color={theme.colors.text.subtle}>
              {t('Dirección')}
            </Text>
            <div>
              {address?.company && <Text type="bodyMRegular">{address.company}</Text>}
              <Text type="bodyMRegular">
                {address?.line_1} {address?.line_2} {address?.house_number}
              </Text>
              <Text type="bodyMRegular">
                {address?.postcode} {address?.locality} {address?.province?.name}
              </Text>
              <Text type="bodyMRegular">
                {address?.country?.name} <CountryFlag code={address?.country?.code} />
              </Text>
            </div>
          </Styles.InfoContainer>
          {contactAddress?.phone && (
            <Styles.InfoContainer>
              <Text type="bodyMRegular" color={theme.colors.text.subtle}>
                {t('Teléfono')}
              </Text>
              <Text type="bodyMRegular">
                +{contactAddress?.phone?.prefix} {contactAddress?.phone?.number}
              </Text>
            </Styles.InfoContainer>
          )}
        </Styles.InfoColumnContainer>
      </Styles.SectionInfoContainer>
    </Styles.SectionContainer>
  )
}

export default CustomerInfoSection
